import { render, staticRenderFns } from "./RegisterStatus.vue?vue&type=template&id=373dd046"
import script from "./RegisterStatus.vue?vue&type=script&lang=js"
export * from "./RegisterStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports